import { render, staticRenderFns } from "./shield.vue?vue&type=template&id=57dd7cf2&scoped=true"
import script from "./shield.vue?vue&type=script&lang=js"
export * from "./shield.vue?vue&type=script&lang=js"
import style0 from "./shield.vue?vue&type=style&index=0&id=57dd7cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dd7cf2",
  null
  
)

export default component.exports